import * as Sentry from "@sentry/react";

import { Env } from "./Env.ts";

// CI E2E and local mock builds run as "test"; their crashes are test failures,
// not production incidents, and would otherwise land in the live project.
const UNREPORTED_ENVS = new Set(["development", "test"]);

if (!UNREPORTED_ENVS.has(Env.VITE_ENV)) {
  Sentry.init({
    dsn: "https://2fd66f931efc56fe770ddb016bb70dd6@o4508922289979392.ingest.us.sentry.io/4508922293452800",
    environment: Env.VITE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of transactions
    // Session Replay
    replaysSessionSampleRate: 0.01, // Keep session sample rate low (1%) to avoid network overhead that can interfere with dynamic chunk loading
    replaysOnErrorSampleRate: 1.0, // Always capture replays when errors occur
  });
}
